import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// material-ui
import { makeStyles, useTheme } from '@mui/styles';
import { AppBar, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// third-party
import clsx from 'clsx';

// project imports
import Breadcrumbs from '../ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import navigation from '../menu-items';
import { drawerWidth } from '../store/constant';
import { SET_MENU } from '../store/actions';

// assets
import { IconChevronRight } from '@tabler/icons-react';

import FixedMenuLayout from './FixedMenuLayout';
// style constant

const drawerWidthOpen = 220;
const drawerWidthClose = 0;
const useStyles = makeStyles((theme) => ({
    content: {
    flexGrow: 1,
    transition: theme.transitions.create(["margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: drawerWidthClose,
    width: `calc(100% - ${drawerWidthClose}px)`,
    },
    contentShift: {
    marginLeft: drawerWidthOpen,
    width: `calc(100% - ${drawerWidthOpen}px)`,
    transition: theme.transitions.create(["margin"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
    },
    root: {
        display: 'flex'
    },
    appBar: {
       backgroundColor: '#ECECEC',
       color:theme.palette.background.secondaryLight
    },
    appBarWidth: {
        transition: theme.transitions.create('width'),
        backgroundColor: '#ECECEC'
    },
    content: {
        ...theme.typography.mainContent,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: 5, //-(drawerWidth - 20),
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '5px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '5px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '5px',
            marginRight: '5px'
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        // marginLeft: drawerWidth ,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '5px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5px'
        }
    },
    footer: {
        marginBottom: '10px'
    },
}));

//-----------------------|| MAIN LAYOUT ||-----------------------//

const MainLayout = ({ children }) => {
    const classes = useStyles();
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const path = location.pathname;
    // Handle left drawer
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const user = useSelector((state) => state.account.user);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };
    React.useEffect(() => {
        if(!matchDownMd){
            dispatch({ type: SET_MENU, opened: !matchDownMd });
        } else {
            setTimeout(() => {
                dispatch({ type: SET_MENU, opened: !matchDownMd });
            }, 300)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    const noMenuPages = [
    '/dashboard',
    '/user_profile_list',
    '/organization_profile_list'
    ];

    const isNoMenuPage = noMenuPages.includes(path);

    return (
        <div className={classes.root} style={{ backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark  }}>
            <CssBaseline />
            {/* header */}
            <AppBar
               // enableColorOnDark
                position="fixed"
                elevation={0}
                className={leftDrawerOpened ? `${classes.appBarWidth} no-print` : `${classes.appBar} no-print`}
            >   
                <Toolbar style={{ backgroundColor: theme.palette.themeMode == 'dark' ? "#1E1E30" : theme.palette.primary.dark  }}>
                    {(path == '/dashboard' || path == '/logout' || path == '/user_profile_list' || path == '/organization_profile_list') &&  
                        <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                    }
                    {/* <Header handleLeftDrawerToggle={handleLeftDrawerToggle} /> */}
                </Toolbar>
                {/* <hr /> */}
                {(path != '/dashboard' && path != '/logout' && path != '/user_profile_list' && path != '/organization_profile_list') && <FixedMenuLayout/> }
            </AppBar>

            {/* drawer */}
            {/* <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} /> */}

            <main 
                style={{
                    backgroundColor: theme.palette.themeMode == 'dark' 
                    ? theme.palette.primary.light 
                    : theme.palette.primary.dark,
                    transition: "margin-left 0.3s ease",
                    marginLeft: isNoMenuPage ? 0 : (leftDrawerOpened ? 220 : 0),
                    marginTop: 56,
                    flexGrow: 1,
                    minHeight: "calc(100vh - 64px)",
                    padding: "16px",
                    boxSizing: "border-box",
                }}
                >
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <div>{children}</div>
            </main>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node
};

export default MainLayout;
